export default __webpack_public_path__ + "static/media/home-service-company.9a0482de.svg";